export default {
  "redemptionCodeConfig.title": "Redemption Code Config",
  "redemptionCodeConfig.column.no": "#NO",
  "redemptionCodeConfig.column.redemptionCode": "Redemption Code",
  "redemptionCodeConfig.column.channel": "Channel",
  "redemptionCodeConfig.column.amount": "Amount",
  "redemptionCodeConfig.column.withdrawLimit": "Withdraw Limit",
  "redemptionCodeConfig.column.enable": "Enable",
  "redemptionCodeConfig.column.createTime": "Create Time",
  "redemptionCodeConfig.column.action": "Action",
  "redemptionCodeConfig.action.details": "Details",
  "redemptionCodeConfig.action.edit": "Edit",
  "redemptionCodeConfig.action.enable": "Enable",
  "redemptionCodeConfig.action.disable": "Disable",
  "redemptionCodeConfig.search.redemptionCode": "Redemption Code",
  "redemptionCodeConfig.search.channel": "Channel",
  "redemptionCodeConfig.search.enable": "Enable",
  "redemptionCodeConfig.form.redemptionCode": "Redemption Code",
  "redemptionCodeConfig.form.amount": "Amount",
  "redemptionCodeConfig.form.withdrawLimit": "Withdraw Limit",
  "redemptionCodeConfig.form.channel": "Channel",
  "redemptionCodeConfig.confirm.enable.title": "Enable Redemption Code: {redemptionCode}",
  "redemptionCodeConfig.confirm.disable.title": "Disable Redemption Code: {redemptionCode}",
  "redemptionCodeConfig.confirm.enable.content": "Are you sure you want to enable this redemption code?",
  "redemptionCodeConfig.confirm.disable.content": "Are you sure you want to disable this redemption code?",
  "redemptionCodeConfig.confirm.ok": "Confirm",
  "redemptionCodeConfig.confirm.cancel": "Cancel",
  "redemptionCodeConfig.add": "Add",
  "redemptionCodeConfig.edit": "Edit",
  "redemptionCodeConfig.details": "Details",
};